export const sendBeginCheckout = (plan: 'lite' | 'plus' | 'pro', amount: number) => {
  if (window.gtag) {
    window.gtag('event', 'begin_checkout', {
      send_to: 'G-ERTZWHGNZQ',
      currency: 'UAH',
      value: amount,
      items: [
        {
          item_name: plan,
        },
      ],
    });
  }
};

export const sendPurchase = (plan: 'lite' | 'plus' | 'pro', amount: number, transaction_id: string) => {
  if (window.gtag) {
    window.gtag('event', 'begin_checkout', {
      send_to: 'G-ERTZWHGNZQ',
      currency: 'UAH',
      transaction_id,
      value: amount,
      items: [
        {
          item_name: plan,
        },
      ],
    });
  }
};

export const sendLogin = (method: 'Google' | 'SMS', email?: string, phone?: string) => {
  if (window.gtag) {
    window.gtag('event', 'login', {
      send_to: 'G-ERTZWHGNZQ',
      method,
      email,
      phone,
    });
  }
};

export const sendSignUp = (method: 'Google' | 'SMS', email?: string, phone?: string) => {
  if (window.gtag) {
    window.gtag('event', 'sign_up', {
      send_to: 'G-ERTZWHGNZQ',
      method,
      email,
      phone,
    });
  }
};
